
import { Component, Prop } from "vue-property-decorator";
import "../../../assets/img/logo.png";
import SecurityService from "frontend-domain/src/domain/security/SecurityService";
import { menu, router } from "../../../configs/router";
import URLS, { UrlsVO } from "frontend-domain/src/domain/UrlsVO";
import BaseComponent from "../../BaseComponent";
import { Profile } from "frontend-domain/src/domain/security/SecuyrityEntities";

@Component({ components: {} })
export default class Menu extends BaseComponent {
    @Prop({ required: false, default: "X.Y.Z" })
    versao: string;
    segService: SecurityService;
    menuExpandido: { [name: string]: boolean } = {};
    urls: UrlsVO = URLS;

    created() {
        this.segService = new SecurityService();
    }

    get rotasPermitidas() {
        // @ts-ignore
        let loggedUser = this.$loggedUser;

        // return this.rotas.filter(rota => {
        return menu.filter((rota) => {
            return (
                rota.meta.menu &&
                (!rota.perfisPermitidos ||
                    (loggedUser.perfis &&
                        rota.perfisPermitidos.filter((pf: any) =>
                            loggedUser.perfis.map((p: Profile) => p.name).includes(pf)
                        ).length > 0))
            );
        });
    }

    logout() {
        this.segService.logout().then(() => this.$emit("logout", true));
    }

    toggleMenu(route: any) {
        if (this.menuExpandido[route.meta.titulo]) this.$set(this.menuExpandido, route.meta.titulo, false);
        else this.$set(this.menuExpandido, route.meta.titulo, true);
    }
}
